import React, { useEffect } from "react"
import { graphql } from "gatsby"
import "./_style.scss"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"
import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Functions
import { isEmpty } from "lodash"

// Switch Language
import { useTranslation } from "react-i18next"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={process.env.GATSBY_SITE_LANG.replace(/_/g, '-')}></html>
      <body className="temp-cookie-policy"></body>
      <SEO seo={seo} lang={props?.data?.lang}/>
    </React.Fragment>
  )
}

const TemplateCookiePolicy = props => {

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'CookieDeclaration';
    script.src = 'https://consent.cookiebot.com/b3821991-2c20-4386-a18f-bd0274313dbe/cd.js';
    script.type = 'text/javascript';
    script.async = true;

    // Append the script to a specific element
    document.querySelector("#CookieDeclarationHtml").appendChild(script);

    // Cleanup function to remove the script
    return () => {
      const scriptElement = document.querySelector("#CookieDeclaration");
      if (scriptElement) {
        scriptElement.remove(); // This removes the script element when the component unmounts
      }
    };
  }, []);

  return (
    <Layout lang={props?.data?.lang}>
      {!isEmpty(props?.pageContext) ? (
        <React.Fragment>
          <div className="container row px-0 mx-auto">
            <h1 className="fs-30 mt-5 mb-4">{props?.pageContext?.title}</h1>
            <div id="CookieDeclarationHtml" className="mb-5"></div>
          </div>
        </React.Fragment>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default TemplateCookiePolicy

export const pageQuery = graphql`
  query GET_TRANSLATIONS($databaseId: Int!) {
    lang: wpPage(databaseId: { eq: $databaseId }) {
      locale {
        locale
      }
      translations {
        href
        locale
      }
    }
  }
`
